import Vue from 'vue';
import Vuex from 'vuex';

import * as Auth from './modules/Auth';
import * as Notification from './modules/Notification';
import * as User from './modules/User';
import * as Email from './modules/Email';
import {fetchApplicationFromContext} from "../services/OpenApiService";
import {cacheContinueUrl} from "@/services/continueService";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        Auth,
        Notification,
        User,
        Email
    },

    state: {
        context: {
            app: null,
            continueUrl: null,
            method: 'token'
        },

        initialized: false
    },

    mutations: {
        CONTEXT_APP_SET(state, data) {
            state.context.app = data.app;
            state.context.continueUrl = data.continueUrl;
            if (data.app.usesAuthProxy) {
                state.context.method = 'code';
            } else {
                state.context.method = data.method || state.context.method;
            }

        },

        CONTEXT_APP_REMOVE(state) {
            state.context.app = null;
            state.context.continueUrl = null;
            state.context.method = 'token';
        },

        APPLICATION_INITIALIZED(state) {
            state.initialized = true
        }
    },

    actions: {
        setContextApplication({commit}, {continueUrl, method}) {
            cacheContinueUrl(continueUrl);
            return fetchApplicationFromContext(continueUrl)
                .then(({data}) => {
                    commit('CONTEXT_APP_SET', {app: data.data, continueUrl, method})
                });
        },

        removeContextApplication({commit}) {
            commit('CONTEXT_APP_REMOVE')
        },

        applicationInitialize({commit}) {
            commit('APPLICATION_INITIALIZED');
        }
    }
});
